import React, { useState, useEffect, useRef } from 'react';
import OrderLedgerBuilder from './OrderLedgerBuilder';
import PositionLedgerSummary from './PositionLedgerSummary';
import PositionLedgerTable from './PositionLedgerTable';
import './PositionLedger.css';

/**
 * PositionLedger - Main container for position tracking
 * Processes rawOrders and displays unified view
 */
function PositionLedger({ rawOrders }) {
  console.log("ðŸ” PositionLedger received rawOrders:", rawOrders?.length || 0);
  console.log("ðŸ” PositionLedger rawOrders sample:", rawOrders?.[0]);
  const [ledgerView, setLedgerView] = useState({
    stocks: [],
    options: [],
    summary: {}
  });
  
  const [isLoading, setIsLoading] = useState(true);
  const ledgerBuilderRef = useRef(new OrderLedgerBuilder());

  useEffect(() => {
    console.log("ðŸ”„ PositionLedger useEffect triggered");
    console.log("ðŸ”„ rawOrders:", rawOrders);
    console.log("ðŸ”„ rawOrders type:", typeof rawOrders);
    console.log("ðŸ”„ rawOrders is array?:", Array.isArray(rawOrders));
    console.log("ðŸ”„ rawOrders length:", rawOrders?.length);
    
    if (!rawOrders) {
      console.log("âš ï¸ rawOrders is null/undefined");
      setIsLoading(false);
      return;
    }
    
    if (rawOrders.length === 0) {
        console.log("⚠️ rawOrders is empty array - keeping prior ledgerView");
        setIsLoading(false);
        return;
      }
      

    try {
      console.log(`ðŸ“Š About to call processOrderHistory with ${rawOrders.length} orders...`);
      console.log("ðŸ“Š ledgerBuilderRef.current:", ledgerBuilderRef.current);
      
      // Process through ledger builder
      const view = ledgerBuilderRef.current.processOrderHistory(rawOrders);
      
      console.log("âœ… processOrderHistory returned:", view);
      console.log("âœ… Ledger view generated:", view);
      console.log("ðŸ“ˆ Stocks:", view.stocks?.length);
      console.log("ðŸ“ˆ Options:", view.options?.length);
      
      setLedgerView(view);
      setIsLoading(false);
    } catch (error) {
      console.error("âŒ Error processing order history:", error);
      console.error("âŒ Error stack:", error.stack);
      setIsLoading(false);
    }
  }, [rawOrders]);

  if (isLoading) {
    return (
      <div className="position-ledger-loading">
        <div className="spinner-border text-primary" role="status">
          <span className="sr-only">Loading positions...</span>
        </div>
      </div>
    );
  }

  console.log("🎨 PositionLedger RENDERING with ledgerView:", ledgerView);
  console.log("🎨 Stocks array:", ledgerView.stocks);
  console.log("🎨 Options array:", ledgerView.options);
  console.log("🎨 Summary:", ledgerView.summary);

  return (
    <div className="position-ledger">
      {/* Summary Bar */}
      <PositionLedgerSummary summary={ledgerView.summary} />

      {/* Stock Positions Section */}
      <div className="ledger-section">
        <h4 className="section-title">
          <i className="bi bi-graph-up"></i> Stock Positions
          <span className="badge bg-primary ms-2">
            {ledgerView.summary.active_stocks || 0} Active
          </span>
          <span className="badge bg-secondary ms-1">
            {ledgerView.summary.closed_stocks || 0} Closed
          </span>
        </h4>
        <PositionLedgerTable 
          positions={ledgerView.stocks || []} 
          assetClass="stock"
        />
      </div>

      {/* Options Positions Section */}
      <div className="ledger-section mt-4">
        <h4 className="section-title">
          <i className="bi bi-lightning"></i> Options Positions
          <span className="badge bg-primary ms-2">
            {ledgerView.summary.active_options || 0} Active
          </span>
          <span className="badge bg-secondary ms-1">
            {ledgerView.summary.closed_options || 0} Closed
          </span>
        </h4>
        <PositionLedgerTable 
          positions={ledgerView.options || []} 
          assetClass="option"
        />
      </div>
    </div>
  );
}

export default PositionLedger;